module.exports = __webpack_public_path__ + "static/media/the-beers.7a45c4e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/beers/the-beers.jpg
// module id = 580
// module chunks = 0